import { CHARACTERS } from './characters.js';
import { GAME, MATCH_PRESETS, ROOM_CODE_ALPHABET } from './constants.js';
export function normalizeNickname(input) {
    if (typeof input !== 'string')
        return '';
    return input.trim().replace(/[<>\u0000-\u001f\u007f]/g, '').slice(0, GAME.nicknameMaxLength);
}
export function normalizeRoomCode(input) {
    if (typeof input !== 'string')
        return '';
    return [...input.toUpperCase()].filter((character) => ROOM_CODE_ALPHABET.includes(character)).join('').slice(0, GAME.roomCodeLength);
}
export function isPresetId(input) {
    return typeof input === 'string' && MATCH_PRESETS.some(({ id }) => id === input);
}
export function isCharacterId(input) {
    return typeof input === 'string' && CHARACTERS.some(({ id }) => id === input);
}
export function clampStat(value) {
    return Math.max(0.7, Math.min(1.3, 1 + ((value - 50) / 50) * 0.3));
}
